import { z } from 'zod';
import { Api } from '@automapa/svelte-automapa-template';

export const CollectUsageDataResponseSchema = z.object({
    month: z.string(),
    customer_id: z.number(),
    customer_name: z.string(),
    route_load_count: z.number(),
    delivery_delivery_count: z.number(),
    delivery_collection_count: z.number(),
    unique_assignment_count: z.number(),
    unique_vehicle_count: z.number(),
    vehicle_json: z.string(),
});
export type CollectUsageDataResponse = z.infer<typeof CollectUsageDataResponseSchema>;

const VehicleSchema = z.object({
    id: z.number(),
    webuser_id: z.number().nullable(),
    email: z.string().nullable(),
    deleted: z.string().nullable(),
});
export type VehicleResponse = z.infer<typeof VehicleSchema>;

export class UsageCollectorApi {
    static async collectUsageData(
        api: Api,
        customer_id: number | null = null
    ): Promise<CollectUsageDataResponse[]> {
        return api.getData<any, CollectUsageDataResponse[]>(
            'post',
            `/admin/collect_usage_data`,
            { customer_id },
            z.any(),
            z.array(CollectUsageDataResponseSchema)
        );
    }

    static async getVehiclesByCustomerId(api: Api, customerId: number): Promise<VehicleResponse[]> {
        return api.getData<any, VehicleResponse[]>(
            'post',
            `/admin/collect_vehicles_by_customer_id`,
            { customer_id: customerId },
            z.any(),
            z.array(VehicleSchema)
        );
    }
}
